import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrolltoTop";

const AboutPage = () => {
  return (
    <>
      <div className="about-page-container">
        <section className="aboutHero" id="hero">
          <h1>HOSTING A VIBRANT COMMUNITY, PROMOTING CULTURE AND CREATIVITY</h1>
        </section>
        <section className="aboutWho">
          <div className="whoText">
            <h3>Who are we?</h3>
            <p>
              We are the AfroCollective. We're on a mission to spotlight and
              elevate Afro-based music from the heart of the UK. Born out of a
              passion for nurturing emerging musical talent, our focus is on
              creating an intimate space for artists to grow together with their
              fans, collectively shaping the narrative of the thriving UK Afro
              music scene. We're dedicated to encouraging the African Diaspora
              in the UK to embrace their heritage through the universal language
              of music.
            </p>
          </div>
          <div className="img-container">
            <img
              src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/whoWeAre.webp"
              alt="whoWeAre"
              fetchpriority="high"
            />
          </div>
        </section>
        <section className="aboutProvide" id="about-provide">
          <h3> Providing a Platform </h3>
          <div className="innerProvide">
            <div className="provideText">
              <div className="sect" id="the-problem">
                <h5> The problem</h5>
                <p>
                  In 2016, upon recognizing a concerning trend in the career
                  longevity of UK Afroswing artists, we embarked on a journey to
                  pinpoint the root cause. Our investigation led us to conclude
                  that there was a dearth of platforms dedicated to promoting
                  these artists. While established platforms like SBTV, Link Up
                  TV, and GRM Daily primarily spotlighted drill and rap, the
                  burgeoning UK Afroswing scene was left without a prominent
                  voice.
                </p>
              </div>
              <div className="sect" id="the-solution">
                <h5>The solution</h5>
                <p>
                  Determined to change this narrative, The AfroCollective
                  emerged as the torchbearers for this new wave. Our flagship
                  initiative, 'The AfroCollective Experience, ' serves as a
                  platform to thrust UK Afro Fusion into the limelight through
                  live streaming events.
                </p>
              </div>
              <div className="sect" id="the-goal">
                <h5>The goal</h5>
                <p>
                  Moreover, we are committed to creating compelling content,
                  including artist interviews, live performances of their
                  tracks, events with Afro Fusion and engaging artist
                  challenges. Through these efforts, we aim to not only showcase
                  the immense talent within the UK Afro Fusion scene but also
                  foster a vibrant community around it.
                </p>
              </div>
              <div className="sect tablet-provide-img" id="the-image">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/provide.webp"
                  alt="About Provide"
                />
                <Link to="/artists" onClick={scrollToTop}>
                  Learn more about our Afro Fusion artists
                </Link>
              </div>
            </div>
            <div className="provideImgLink">
              <div className="img-container">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/provide.webp"
                  alt="About Provide"
                />
              </div>
              <Link to="/artists" onClick={scrollToTop}>
                Learn more about our Afro Fusion artists
              </Link>
            </div>
          </div>
        </section>
        <section className="aboutConnect" id="about-connect">
          <div className="connectContainer">
            <div className="connectImgContainer">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/connecting.webp"
                alt="Home Connect"
                className="connectImg"
              />
            </div>
            <div className="connectText">
              <div className="text-only">
                <h3>Connecting artists to their supporters</h3>
                <div className="connectMImgContainer">
                  <img
                    src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/connecting.webp"
                    alt="Home Connect"
                    className="connectImg"
                  />
                </div>
                <p>
                  The Afrocollective events feature a set dedicated to playing
                  UK Afro Fusion, a genre that has long been neglected by many
                  event organisers and DJs. These sets allow our audience to
                  discover up and coming artists within the UK music scene,
                  growing the fanbase of the artists and the genre as a whole.
                  Additionally, our platform has created a community within the
                  Afro Fusion scene, connecting the artists to their supporters.
                </p>
              </div>
              <Link to="/events" onClick={scrollToTop}>
                <button className="desktopBtn">View events</button>
              </Link>
            </div>
          </div>
        </section>
        <section className="aboutWhat" id="about-what">
          <div className="whatInner">
            <h3>What is Afro Fusion?</h3>
            <div className="whatRow1">
              <div className="part1">
                {" "}
                <p>
                  Afro Fusion is highly diverse and intricate. It fundamentally
                  combines traditional Afrobeats with various other sounds,
                  including the nostalgic bells of old UK Afroswing, the
                  distinctive log drums of Amapiano, and the retro vibes of
                  Alte-fusion. With the short lifespan of UK Afroswing, and a
                  change in sounds, a new genre to describe many of the UK
                  artist was needed. Hence the introduction of Afro Fusion.
                </p>
              </div>
              <div className="part2">
                {" "}
                <p>
                  Rooted in Africa’s diverse musical heritage, Afro Fusion has
                  evolved through the influence of artists who fuse indigenous
                  sounds with modern production techniques, creating an
                  ever-evolving genre. This fusion preserves African musical
                  traditions and also propels them onto the global stage.
                </p>
              </div>
            </div>
            <div className="whatRow2">
              <div className="part1">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/whatImg.webp"
                  alt="What"
                ></img>
              </div>
              <div className="part2">
                <h4>What about Afroswing?</h4>
                <p>
                  “The roots of Afroswing can be traced back to London's
                  multicultural neighbourhoods, such as Brixton, Tottenham, and
                  Hackney, where a diverse group of artists began experimenting
                  with combining various musical influences. Here, African and
                  Caribbean sounds blended with UK urban music genres like grime
                  and garage during this time. The result was a fresh and
                  innovative sound that resonated with a growing audience
                  seeking something new and exciting.” -Brian Omowumi
                </p>
                <br />
                <Link to="https://www.khadsarkmagazine.com/afroswing-the-rise-the-decline-the-re">
                  Afroswing: The Rise, The Decline, The Revival?
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="timeline">
          <h3>The AfroCollective formation timeline</h3>
          <div className="timeline-main"></div>
          <div className="timeline-triangle"></div>
          <div className="timeline-stop left">
            <h4 className="mobile-tlh4">September 2021</h4>
            <div className="img-container">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/sept2021.webp"
                alt="firstimg"
              />
            </div>
            <div className="stop-text">
              <div className="timeline-small"></div>
              <h4>September 2021</h4>
              <p>
                The AfroCollective began as managers for Jay Biz, a UK Afro
                Fusion artist. During this time as managers we noticed 2 things;
                we didn’t hear Jay Biz's music in parties, although he had
                hundreds of thousands of streams; Jay Biz and his peers weren't
                getting booked to perform at events.
              </p>
            </div>
          </div>
          <div className="timeline-stop right">
            <div className="stop-text">
              <div className="timeline-small"></div>
              <h4>March 2023</h4>
              <p>
                {" "}
                We decided that if no one is going to book our artist, we should
                create an event that is focused on UK music so we can hear their
                songs at parties and hear them perform.
              </p>
            </div>
            <div className="img-container">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/mar2023.webp"
                alt="firstimg"
              />
            </div>
            <h4 className="mobile-tlh4">March 2023</h4>
          </div>
          <div className="timeline-stop left">
            <h4 className="mobile-tlh4">September 2023</h4>
            <div className="img-container">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/sept2023.webp"
                alt="firstimg"
              />
            </div>
            <div className="stop-text">
              <div className="timeline-small"></div>
              <h4>September 2023</h4>
              <p>
                Our first event was on the 1st of September at a small 200
                capacity venue, where we invited other artists in the scene, and
                thus created The AfroCollective.
              </p>
            </div>
          </div>
          <div className="timeline-stop right">
            <div className="stop-text">
              <div className="timeline-small"></div>
              <h4>Today</h4>
              <p>
                Since then we have hosted over 1000 attendees, gained over 2500
                followers across all our social media platforms, and still keep
                UK Afro Fusion at the forefront of what we do.
              </p>
            </div>
            <div className="img-container">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/today.webp"
                alt="firstimg"
              />
            </div>{" "}
            <h4 className="mobile-tlh4">Today</h4>
          </div>
        </section>
        <div className="leaves-container">
          <img
            className="big-leaves"
            src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/bigLeaves.webp"
            alt=""
          />
          <section className="aboutCom">
            <img
              src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/tacCommunity.webp"
              alt="tacCommunity"
            />
            <div className="aboutComText">
              <h3>The AfroCollective for the community</h3>
              <div className="aboutComTileContainer">
                <div className="aboutComTile">
                  <h5>Third spaces</h5>
                  <p>
                    With the recent eradication of third spaces, young people
                    are desperately in need of somewhere that isn’t a work or
                    education environment. The AfroCollective helps with this as
                    it encourages attendees to relax and just enjoy the cultured
                    performances, this also gives attendees the opportunity to
                    diversify their network.
                  </p>
                </div>
                <div className="aboutComTile">
                  <h5>Pride</h5>
                  <p>
                    In a world of code switching and surprising culture, it can
                    be hard for young African adults to form a genuine and
                    positive connection to their heritage. The AfroCollective
                    provides a space for African and Caribbean people to feel at
                    home and celebrate their heritage. With performances
                    inspired by artists who are also embracing their  heritage.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="aboutChecks">
            <div className="content">
              <div className="inner">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/checkbox.svg"
                  alt="Checkbox"
                />
                <span>
                  Over 1000 <br /> attendees
                </span>
              </div>
              <div className="inner">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/checkbox.svg"
                  alt="Checkbox"
                />
                <span>
                  Over 2500 <br /> followers
                </span>
              </div>
              <div className="inner">
                <img
                  src="https://d1g9iww9o5ioh1.cloudfront.net/about_page/checkbox.svg"
                  alt="Checkbox"
                />
                <span>
                  8 Afro Fusion <br /> artists
                </span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
